import { render, staticRenderFns } from "./ChatGptWidget.vue?vue&type=template&id=679abcea&scoped=true&"
import script from "./ChatGptWidget.vue?vue&type=script&lang=js&"
export * from "./ChatGptWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatGptWidget.vue?vue&type=style&index=0&id=679abcea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679abcea",
  null
  
)

export default component.exports